import styled from 'styled-components'

export const Wrapper = styled.main`
  max-width: 1440px;
  width: 90%;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
  color: #fff;

  img {
    margin-left: 18px;
  }
`

export const Nav = styled.nav`
  ul {
    display: flex;
    justify-content: center;

    li {
      list-style: none;
      margin-left: 16px;
    }
  }
`

export const WrapperLeft = styled.div`
  display: flex;
  align-items: center;
`

export const WrapperRight = styled.div`
  display: flex;
  align-items: center;

  svg,
  button {
    margin-right: 18px;
  }

  svg {
    cursor: pointer;
  }
`
